
import {getCountOnline} from '../api/getCountOnline';
import {setGetCountOnlineAction} from '../action';

const setGetCountOnline = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCountOnline(params);

            if (data.status === 'success') {
                dispatch(setGetCountOnlineAction(data.data))
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetCountOnline
}